/**
 * Descarga un archivo desde una respuesta Axios que contiene un blob.
 * 
 * @param {AxiosResponse} response Respuesta de Axios con el blob.
 * @param {object} options 
 * @param {string} options.fallbackFileName Nombre del archivo a descargar si no se puede obtener el nombre del header 'Content-Disposition'.
 * @param {boolean} [options.useFallbackOnly=false] Indica si solo se debe usar el nombre de archivo proporcionado en 'fallbackFileName' sin intentar obtenerlo desde el header 'Content-Disposition'.
 */
export const downloadFileFromResponse = (response, { fallbackFileName, useFallbackOnly = false }) => {
  let fileNameToUse = fallbackFileName;

  // Si 'useFallbackOnly' es falso, se intenta obtener el nombre del archivo desde el header 'Content-Disposition'
  if (!useFallbackOnly) {
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^;"]+)"?/i);
      const filenameFromHeader = match?.[1];
      if (filenameFromHeader) {
        fileNameToUse = decodeURIComponent(filenameFromHeader.trim());
      }
    }
  }

  const blob = new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileNameToUse);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};